export const FETCH_TICKET_DEPENDANTS = 'FETCH_TICKET_DEPENDANTS';
export const SET_TICKET_DEPENDANTS_LOADING = 'SET_TICKET_DEPENDANTS_LOADING';
export const SET_TICKET_DEPENDANTS = 'SET_TICKET_DEPENDANTS';
export const GET_TICKET_DEPENDANTS = 'GET_TICKET_DEPENDANTS';
export const DELETE_TICKET_DEPENDANT = 'DELETE_TICKET_DEPENDANT';
